import styled from "styled-components";

export const Section = styled.div`
  position: absolute;
  top: 250px;
  width: 80%;
  height: 300px;
  left: "50%";
  transform: "translate(-50%, -50%)";
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);
`;

export const BoxHeader: any = styled.div`
  margin-top: 10px;
  background: #ffffff;
  border-radius: 8px;
  overflow: auto;
  max-height: ${(props: any) => (props.length === 1 ? "115" : "500")}px;
  .name {
    height: 22px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.01em;
    margin-right: 10%;
    color: #424248;
  }
  .information {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #828282;
  }
`;

export const FlexBox = styled.div`
  display: flex;
  justify-content: left;
  padding: 16px;
  border: 1px solid #ececec;
  border-radius: 8px;
`;

export const Td = styled.div`
  margin-right: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  height: 32px;
  background: #eaefff;
  border: 1px solid #eaefff;
  border-radius: 8px;
  :hover {
    cursor: pointer;
  }
  p {
    width: 99px;
    height: 14px;

    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 14px;

    letter-spacing: -0.01em;

    color: #2d5bff;
  }
`;

export const TextStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  background: #eaefff;
  border: 1px solid #eaefff;
  border-radius: 8px;

  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 1rem;
    line-height: 14px;
    letter-spacing: -0.01em;

    color: #000000;
  }
`;

export const List = styled.div`
  flex-direction: column;
  gap: 8;
`;

export const Modalstyle = {
  // position: "absolute" as const,
  // top: "300px",
  // left: "49.7%",
  // transform: "translate(-50%, -50%)",
  marginTop: "280px",
  marginLeft: "118px",
  marginRight: "118px",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 2,
  boxShadow: 2,
  pt: 2,
  px: 4,
  pb: 3,
};
